import React, {useState} from 'react';
import Image from "next/image";
import messagesIcon from "@/app/assets/images/profileDropdown/icons/message.svg";
import contactsIcon from "@/app/assets/images/profileDropdown/icons/contacts.svg";
import calendarIcon from "@/app/assets/images/profileDropdown/icons/calendar.svg";
import settingsIcon from "@/app/assets/images/profileDropdown/icons/settings.svg";
import logoutIcon from "@/app/assets/images/profileDropdown/icons/logout.svg";
import {useTranslation} from "react-i18next";
import {logout} from "@/app/actions/formActions";
import Link from "@/app/components/providers/proxyProvider/Link";
import {useAppContext} from "@/app/context/UserContext";
import NotificationNumber from "@/app/components/notification-number/NotificationNumber";

const DropdownItems = (openNotification,notification) => {
    const [selectedValue, setSelectedValue] = useState({value: 'Euro (€)', key: 1});
    const {isSeeker,meetingNotificationsNumber} = useAppContext();
    const {t} = useTranslation();

    const handleValueClick = (value, key) => {
        setSelectedValue({value: value, key: key})
    }

    const items = [{
        label: <span className={`dropdown-item`} onClick={(e) => handleValueClick('Euro (€)', 1)}>Euro (€)</span>,
        key: 1,
        value: 'Euro (€)'
    }, {
        label: <span className={`dropdown-item`}
                     onClick={(e) => handleValueClick('Dollar ($)', 2)}>Dollar ($)</span>, key: 2, value: 'Euro (€)'
    }, // {
        //     type: 'divider',
        // },
        {
            label: <span className={`dropdown-item`} onClick={(e) => handleValueClick('GBP (£)', 3)}>GBP (£)</span>,
            key: 3,
            value: 'GBP (£)'
        },];

    const profileItems = [{
        key: 1, label: ( <Link href={'/messages'} rel="noopener noreferrer">
                <Image src={messagesIcon} alt={'messages icon'}/>
                    {t('navbar.messages')} <NotificationNumber notificationNumber={notification}/>
            </Link>),
    },!isSeeker && {
        key: 2, label: (<Link href={'/contacts'} rel="noopener noreferrer">
            <Image style={{marginRight: '23px'}} src={contactsIcon} alt={'contacts icon'}/>
                {t('navbar.contacts')}
        </Link>)
    }, {
        key: 3, label: (<Link href={'/calendar'}>
                <Image src={calendarIcon} alt={'calendar icon'}/>
                    {t('navbar.calendar')}  <NotificationNumber notificationNumber={meetingNotificationsNumber}/>
            </Link>),
    }, {
        key: 4, label: (<Link href={'/account'}  rel="noopener noreferrer">
                <Image src={settingsIcon} alt={'settings'}/>
                    {t('navbar.settings')}
            </Link>),
    }, {
        type: 'divider',
    }, {
        key: 5, label: (<form style={{width: '100%'}} action={() => logout().then((status) => {
            if (status > 299 && status <= 199) {
                if (status === 401 || status === 403) {
                    openNotification('error', 'bottomRight', t('notifications.unauthenticated'))
                } else {
                    openNotification('error', 'bottomRight', t('notifications.serverError'))
                }
            }
        })} >
                    <button style={{border: 'none', background: 'none', outline: 'none', fontSize: 16, padding: 0,width: '100%',textAlign: 'left'
                        ,cursor: 'pointer',display:'flex',alignItems:'center'}}
                            type='submit'>
                        <Image style={{marginLeft: '25px',marginRight: '25px'}} src={logoutIcon} alt={'logout'}/>
                        <a target="_blank" rel="noopener noreferrer">
                            {t('navbar.logout')}
                        </a>
                    </button>
            </form>),
    },];

    return {items, profileItems, selectedValue};
};

export default DropdownItems;